export const APP_STATUS = {
    IDLE: 'IDLE',
    FETCHING: 'FETCHING',
    READY: 'READY',
    ERROR: 'ERROR'
};